import React from "react";
import { Link, useNavigate } from "react-router-dom";
import logo from "./img/Medco_full_Logo.png";
import "./css/LandingStyle.css";

const Navbar = ({ onBookDemo }) => {
  const navigate = useNavigate();

  return (
    <nav className="nav-container">
      <div className="nav-logo-section">
        <Link to="/" className="logo-wrapper">
          <img src={logo} alt="Med-CO" />
          <span className="brand-name">Med-CO</span>
        </Link>
      </div>

      <div className="nav-actions">
        <button
          className="login-text-btn"
          onClick={() => navigate("/authentication/sign-in")}
        >
          Log in
        </button>
        <button className="book-demo-pill" onClick={onBookDemo}>
          Book Demo
        </button>
      </div>
    </nav>
  );
};

export default Navbar;
